import React from 'react'

import ControlledModal from '../../../components/modals/ControlledModal'
import EditFieldsForm from './EditFieldsForm'
import FieldsLoader from './_load/FieldsLoader'
import ModalHeader from './ModalHeader'
import IntegrationsLoader from './_load/IntegrationsLoader'

const EditFieldsModal = props => {
  return (
    <ControlledModal width="90vw" noCloseButton {...props}>
      <ModalHeader />
      <IntegrationsLoader>
        <FieldsLoader>
          <EditFieldsForm />
        </FieldsLoader>
      </IntegrationsLoader>
    </ControlledModal>
  )
}

export default EditFieldsModal
